import { useMemo } from 'react'

import { useTranslation } from 'react-i18next'

import { ProductSpreadType } from '@enechain/eposition-proto/types/v1/deal_pb'

type Option<T = string> = {
  label: string
  value: T
}

// memo: 幾らか enum を radio UI のために string に mapping している
type Result = {
  productSpreadTypes: Option[]
  enabledOptions: Option[]
}

export function useSpreadTypeOption(): Result {
  const { t } = useTranslation(['domain', 'common'])
  const productSpreadTypes = useMemo(() => {
    return [
      {
        label: t('domain:shared.area.title'),
        value: ProductSpreadType.AREA.toString(),
      },
      {
        label: t('domain:shared.delivery_date_range'),
        value: ProductSpreadType.DELIVERY_PERIOD.toString(),
      },
      {
        label: t('domain:shared.delivery_hour_type.title'),
        value: ProductSpreadType.HOUR_TYPE.toString(),
      },
    ]
  }, [t])

  const enabledOptions = useMemo(() => {
    return [
      { label: t('common:form.label.is_disabled'), value: 'false' },
      { label: t('common:form.label.is_enabled'), value: 'true' },
    ]
  }, [t])

  return {
    productSpreadTypes,
    enabledOptions,
  }
}
